import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";
import environment from "../../environment";
import { toast } from "react-toastify";
import { useTranslation } from "ceco-polyglot";

import "./trendButton.scss";
const TrendButton = ({ recipeId, trend, recipeName, reload, refetchData, ...rest }) => {
  const [loading, setLoading] = useState(false);
  const t = useTranslation();

  function changeTrend() {
    setLoading(true);
    return new Promise((resolve, reject) => {
      const variables = {
        id: recipeId,
      };

      commitMutation(environment, {
        mutation: trend
          ? trendButton_delete_Mutation
          : trendButton_create_Mutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          setLoading(false);
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    changeTrend()
      .then((a) => {
        if (trend) {
          toast.success(
            t("warning.not_isTrend_recipe", {
              recipeName: recipeName,
            })
          )

          if (reload) {
            refetchData()
          }
        } else {
          toast.success(
            t("warning.isTrend_recipe", {
              recipeName: recipeName,
            })
          );
        }
      })
      .catch((e) => {
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0]?.message);
        }
      });
  };

  return (
    <Icon
      name="heart"
      onClick={() => !loading && onSubmit()}
      className={trend !== false ? "trendButton active" : "trendButton"}
    />
  );
};

export default TrendButton;
const trendButton_create_Mutation = graphql`
  mutation TrendButtonCreateMutation($id: ID!) {
    recipeUpdate(input: { id: $id, isTrend: true }) {
      recipe {
        id
        isTrend
      }
    }
  }
`;
const trendButton_delete_Mutation = graphql`
  mutation TrendButtonDeleteMutation($id: ID!) {
    recipeUpdate(input: { id: $id, isTrend: false }) {
      recipe {
        id
        isTrend
      }
    }
  }
`;
